import React from 'react'
import { Button, Divider, Grid} from "@mui/material";
import { HorizontalSplit } from '@mui/icons-material';

export const ButtonType = {
    NEW_GLASSES: 'new_glasses',
    NEW_CONTACTS: 'new_contacts',
    FRAME: 'frame',
    LENS: 'lens',
    CONTACT_LENS: 'contact_lens',
    SERVICES: 'services',
    TREATMENTS: 'treatments',
    ACCESSORIES: 'accessories',
    SEND_TO_LAB: 'send_to_lab'
}

function InvoiceButtonComponent({onButtonClick}) {

    const handleButtonClick = (buttonType) => {
        onButtonClick(buttonType);
    }

  return (
    <Grid container spacing={1}>
    <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.NEW_GLASSES) }>New Glasses</Button>
    </Grid>
    <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.CONTACT_LENS)}>Contact Lenses</Button>
    </Grid>
    <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.FRAME)}>Frame</Button>
    </Grid>
    {/* <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.LENS)}>Lens</Button>
    </Grid> */}
    <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.SERVICES)}>Services</Button>
    </Grid>
    {/* <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.TREATMENTS)}>Treatments</Button>
    </Grid> */}
    <Grid item>
        <Button variant="outlined" onClick={() => handleButtonClick(ButtonType.ACCESSORIES)}>Accessories</Button>
    </Grid>
    {/* <Grid item>
        <Divider orientation='vertical' />
    </Grid> */}
    {/* <Grid item>
        <Button variant='contained' onClick={() => handleButtonClick(ButtonType.SEND_TO_LAB)}>Send to Lab</Button>
    </Grid>     */}
</Grid>
  )
}

export default InvoiceButtonComponent